import React, { FC } from "react";
import { useField, useFormikContext } from "formik";
import RichTextField, { RichTextFieldProps } from "../RichTextField";

export type FormikRichTextFieldProps = { name: string } & RichTextFieldProps;

const FormikRichTextField: FC<FormikRichTextFieldProps> = ({
  name,
  helperText,
  ...props
}) => {
  const [field, meta] = useField(name);
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const { touched, error } = meta;

  const innerHelperText = touched && Boolean(error) ? error : helperText;

  return (
    <RichTextField
      value={field.value}
      onChange={(val) => setFieldValue(name, val)}
      onBlur={() => setFieldTouched(name, true)}
      error={touched && Boolean(error)}
      helperText={innerHelperText}
      {...props}
    />
  );
};

export default FormikRichTextField;
